import './MainAppStyle.css';
import React from 'react';
import { Provider as ReactReduxProvider } from 'react-redux'
import { Outlet, RouterProvider } from 'react-router-dom';
import { Header } from '../features/header/Header';
import { store } from '../store/store';
import { browserRouter } from './routes';
import { InfoPopup } from '../features/info_popup/InfoPopup';

/** Top level for react-router. */
export function AppInner()
{
  return (
    <div className='ernots_App'>
      <Header/>
      <main className='ernots_MainContent'>
        <Outlet />
        <InfoPopup/>
      </main>
    </div>
  );
}

/** The component rendered by index.tsx. */
export function App()
{
  return (
    <React.StrictMode>
      <ReactReduxProvider store={store}>
        <RouterProvider router={browserRouter} />
      </ReactReduxProvider>
    </React.StrictMode>)
}